import { API_URL_BASE, htmlElem, contentElem } from '../utils/globals';
import { primaryDir } from '../utils/documentLocation';
import { setAjaxLoading, setAjaxComplete } from '../utils/ajaxLoaders';
import { removeChildNodes } from '../utils/removeChildNodes';
import { resetEmptyBlogItems } from '../utils/resetEmptyBlogItems';
import { addToSessionStorage } from '../utils/utilsStorage';
import { protectedPages } from '../utils/protectedPages';
import { updatePushState } from '../utils/updatePushState';
import { IS_PRIVATE } from '../utils/utils';
import { modal } from './modal';

const fetchPageOnLoad = () => {
    if (!protectedPages.includes(primaryDir) && primaryDir) {
        fetch(`${API_URL_BASE}/pages?slug=${primaryDir}`)
            .then((response) => response.json())
            .then((data) => {
                setAjaxLoading(htmlElem);
                if (!data.length) {
                    return;
                } else if (data[0].tags.includes(6) && !IS_PRIVATE) {
                    window.location = `/login/`;
                    addToSessionStorage('pageId', primaryDir);
                } else {
                    removeChildNodes(contentElem);
                    const template = `<section>${data[0].content.rendered}</section>`;
                    contentElem.insertAdjacentHTML('beforeend', template);
                    updatePushState(primaryDir);
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                resetEmptyBlogItems();
                setAjaxComplete(htmlElem);
                modal();
            });
    } else {
        return;
    }
}

export {
    fetchPageOnLoad
}